<main class="auth-callback" aria-live="polite">
  <span class="spinner" aria-hidden="true"></span>
  <p>{{ loaderText() }}</p>
</main>
